export class OptionValue {
    public id: number;
    public category_id: number | null;
    public name: string;
    public value: string;
    public sort_order: number;

    constructor(data: OptionValueData | void) {
        if (data === undefined) {
            this.id = 0;
            this.category_id = null;
            this.name = "";
            this.value = "";
            this.sort_order = 0;
        } else {
            this.id = data.id;
            this.category_id = data.category_id;
            this.name = data.name;
            this.value = data.value;
            this.sort_order = data.sort_order;
        }
    }

    public resetToDefaults(): void {
        this.id = 0;
        this.category_id = null;
        this.name = "";
        this.value = "";
        this.sort_order = 0;
    }
}

export type OptionValueData = {
    id: number;
    category_id: number | null;
    name: string;
    value: string;
    sort_order: number;
}
